import React from 'react';
import Slider from 'react-slick';
import { func, string, number, bool } from 'prop-types';

// Import logic
import { useGallery } from '../hooks';

// Import components
import GalleryItem from './GalleryItem';
import Description from './Description';
import SliderArrow from 'components/elements/molecules/slider/SliderArrow/SliderArrow';

// Import helpers
import { sliderOptions } from '../helpers';

// Import styles
import { Container } from '../styles';

// Import variables
import { SLIDER_ARROW_TYPES } from 'helpers/variables';

const { PREV, NEXT } = SLIDER_ARROW_TYPES;

const Gallery = (props) => {
	const { cursor, onItemClick, smallGalleryIndex, isFullscreen } = props;

	const {
		gallery,
		galleryRef,
		containerWidth,
		assetHeight,
		showGallery,
		currentIndex,
		setCurrentIndex,
		isArticle
	} = useGallery(props);

	if (!showGallery) return null;

	const { assets, metadata } = gallery;

	const commonGalleriesProps = {
		assetsInGallery: assets.length,
		galleryMetadata: metadata,
		isFullscreen,
		isLightBackground: isArticle
	};

	return (
		<Container
			ref={galleryRef}
			isFullscreen={isFullscreen}
			isLightBackground={isArticle}
		>
			{containerWidth && (
				<>
					<Slider
						{...sliderOptions}
						initialSlide={smallGalleryIndex}
						afterChange={setCurrentIndex}
						nextArrow={<SliderArrow type={NEXT} slideHeight={assetHeight} />}
						prevArrow={<SliderArrow type={PREV} slideHeight={assetHeight} />}
					>
						{assets.map((item, index) => (
							<GalleryItem
								key={item.id}
								index={index}
								width={containerWidth}
								height={assetHeight}
								cursor={cursor}
								onItemClick={onItemClick}
								{...item}
								{...commonGalleriesProps}
							/>
						))}
					</Slider>
					<Description
						assets={assets}
						index={currentIndex}
						isLightBackground={isArticle}
						{...commonGalleriesProps}
					/>
				</>
			)}
		</Container>
	);
};

Gallery.defaultProps = {
	onHeightChange: () => {},
	cursor: 'default',
	onItemClick: () => {},
	smallGalleryIndex: 0,
	setSmallGalleryIndex: () => {},
	isFullscreen: false
};

Gallery.propTypes = {
	onHeightChange: func,
	cursor: string,
	onItemClick: func,
	smallGalleryIndex: number,
	setSmallGalleryIndex: func,
	descriptionHeight: string,
	isFullscreen: bool
};

export default Gallery;
